import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Applications } from '@core/app/scripts/services/applications';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { Language } from '@shared/app/scripts/services/language';
import { NotificationManager } from '@shared/app/scripts/services/notification-manager';
import { Session } from '@shared/app/scripts/services/session';
import { Updates, IUpdate } from '@www/app/scripts/services/updates';

/**
 * Component that is displayed at /home route
 *
 * # Example
 * <pre>
 *   <home></home>
 * </pre>
 */
angular.module('gateApp').component('home', {
  template: require('./home.html').default,
  controller: class {
    userName$: Observable<string>;
    applicationsList: any[];
    languageId: string;
    appPromise: ng.IPromise<any>;
    updatesPromise: ng.IPromise<IUpdate[]>;

    constructor(
      private $routeParams: ng.route.IRouteParamsService,
      private $translate: ng.translate.ITranslateService,
      private applications: Applications,
      private language: Language,
      private moment,
      private notificationManager: NotificationManager,
      private session: Session,
      private updates: Updates,
    ) {}

    $onInit() {
      this.userName$ = this.session.current$.pipe(
        map((currentSession: CurrentSession) => currentSession.username),
      );

      this.languageId = this.language.current;

      // TODO add unit tests
      this.updatesPromise = this.updates.getAll();

      this.appPromise = this.applications
        .supported()
        .then((apps) => (this.applicationsList = apps));

      if (this.$routeParams.error) {
        const errorInfo = this.$translate.instant(this.$routeParams.error);
        let errorMessage = '';

        // hack to know if key was translated successfully
        if (errorInfo === this.$routeParams.error) {
          errorMessage = this.$translate.instant('gate.generic_error', {
            error: errorInfo,
          });
        } else {
          errorMessage = errorInfo;
        }

        this.notificationManager.sendError(errorMessage, undefined, 0);
      }
    }
  },
});
